var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyActionitems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Action_items",
    transform: "translate(17551.164 11999.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12346",
    transform: "translate(-16.894 99.561)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17510.3-12063.8c-6.2,0-11.2-5-11.2-11.2c0-6.2,5-11.2,11.2-11.2s11.2,5,11.2,11.2 C-17499.1-12068.9-17504.1-12063.8-17510.3-12063.8z M-17510.3-12083.4c-4.6,0-8.4,3.8-8.4,8.4c0,4.6,3.8,8.4,8.4,8.4 s8.4-3.8,8.4-8.4C-17501.9-12079.6-17505.6-12083.4-17510.3-12083.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17511.6-12071.5c-0.4,0-0.7-0.1-1-0.4l-2-2c-0.5-0.5-0.5-1.4,0-2c0.5-0.5,1.4-0.5,2,0l1.1,1.1l4-3.5 c0.6-0.5,1.4-0.5,2,0.1s0.5,1.4-0.1,2l-4.9,4.4C-17510.9-12071.6-17511.3-12071.5-17511.6-12071.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12347"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17505.3-11973.5h-5.5c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h5.5c0.8,0,1.4,0.6,1.4,1.4 C-17503.9-11974.2-17504.5-11973.5-17505.3-11973.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17512.1-11980.5c-0.5,0-1-0.3-1.2-0.8c-0.3-0.7-0.1-1.5,0.6-1.9l3.1-1.6c0.7-0.3,1.5-0.1,1.9,0.6 c0.3,0.7,0.1,1.5-0.6,1.9l-3.1,1.6C-17511.7-11980.5-17511.9-11980.5-17512.1-11980.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17509-11965.1c-0.2,0-0.4,0-0.6-0.1l-3.1-1.6c-0.7-0.3-1-1.2-0.6-1.9s1.2-1,1.9-0.6l3.1,1.6 c0.7,0.3,1,1.2,0.6,1.9C-17508-11965.3-17508.5-11965.1-17509-11965.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12348",
    transform: "translate(-17550.164 -11997.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,23.6H1.1c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h5.5c0.8,0,1.4,0.6,1.4,1.4 C7.9,23,7.3,23.6,6.6,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,16.7c-0.2,0-0.4,0-0.6-0.1L4.2,15c-0.7-0.3-1-1.2-0.6-1.9c0.3-0.7,1.2-1,1.9-0.6l3.1,1.6 c0.7,0.3,1,1.2,0.6,1.9C8.9,16.4,8.5,16.7,7.9,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8,32.1c-0.5,0-1-0.3-1.2-0.8c-0.3-0.7-0.1-1.5,0.6-1.9l3.1-1.6c0.7-0.3,1.5-0.1,1.9,0.6 c0.3,0.7,0.1,1.5-0.6,1.9l-3.1,1.6C5.3,32,5,32.1,4.8,32.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyActionitems);
export default __webpack_public_path__ + "static/media/My Action items.e83eedad021dbd5fba092971a37e8e50.svg";
export { ForwardRef as ReactComponent };